@if (showComponent()) {
    <div class="container-fluid well">
        <div class="row">
            <div class="col-xs-12">
                <div class="row height30">
                    <div class="col-md-9 h5">{{title}}</div>
                </div>
                <h6>Select the survey method and plan content variations granted by the <i>Inspector of Plans and Surveys</i> for this plan</h6>
                <table class="table table-hover table-striped">
                    <thead>
                        <tr class="default">
                            <th
                                nowrap
                                class="col-md-3"
                                title="Variation type">
                                Variation type
                            </th>
                            <th
                                nowrap
                                class="col-md-5"
                                title="Variation regulatory statement">
                                Variation regulatory statement
                            </th>
                            <th
                                nowrap
                                class="col-md-3"
                                title="Approval reference">
                                Approval reference
                            </th>
                            <th
                                nowrap
                                class="col-md-1">
                                Actions
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (variationApproval of getVariationApprovals(); track variationApproval; let i = $index; let last = $last) {
                            <tr>
                                <td class="text-left vertical-middle">
                                    <ng-select
                                        class="nlr-ng-select nlr-ng-select-fit-content"
                                        [ngClass]="{'has-error': variationType | formFieldHasError}"
                                        [searchable]="false"
                                        [clearable]="false"
                                        [name]="'variationType' + i"
                                        [id]="'variationType' + i"
                                        placeholder="Select"
                                        title="Select a variation type"
                                        [disabled]="isVariationTypeDisabled()"
                                        [items]="variationTypes"
                                        [trackByFn]="variationTypeTrackBy"
                                        bindLabel="variationName"
                                        [ngModel]="variationApproval.variationType"
                                        (change)="variationTypeChange(variationApproval, $event)"
                                        (open)="variationTypeCloseTooltip('variationType' + i)"
                                        (close)="variationTypeCloseTooltip('variationType' + i)"
                                        #variationType="ngModel">
                                        <ng-template
                                            ng-option-tmp
                                            let-item="item">
                                            <div
                                                [nlrTooltip]="item.variationName"
                                                [nlrTooltipParent]="'variationType' + i"
                                                [nlrTooltipPosition]="'top'">
                                                {{item.variationName}}</div
                                            >
                                        </ng-template>
                                    </ng-select>
                                </td>
                                <td
                                    class="vertical-middle"
                                    [ngClass]="{'has-error': regulatoryStatement | formFieldHasError}">
                                    <div class="input-group">
                                        <span class="input-group-addon corner">
                                            <i class="nlrp-icon nlrp-icon-edit corner-icon"></i>
                                        </span>
                                        <textarea
                                            class="form-control"
                                            placeholder="Enter regulatory statement details"
                                            rows="2"
                                            cols="40"
                                            [maxlength]="255"
                                            [attr.name]="'regulatoryStatement' + i"
                                            [name]="'regulatoryStatement' + i"
                                            [(ngModel)]="variationApproval.regulatoryStatement"
                                            [required]="!isRegulatoryStatementDisabled(variationApproval)"
                                            [disabled]="isRegulatoryStatementDisabled(variationApproval)"
                                            #regulatoryStatement="ngModel">
                                        </textarea>
                                    </div>
                                </td>
                                <td
                                    class="text-center vertical-middle"
                                    [ngClass]="{'has-error': approvalReference | formFieldHasError}">
                                    <div class="input-group">
                                        <span class="input-group-addon">
                                            <i class="nlrp-icon nlrp-icon-edit"></i>
                                        </span>
                                        <input
                                            type="text"
                                            class="form-control"
                                            placeholder="Approval Reference"
                                            title="Enter approval reference"
                                            [attr.name]="'approvalReference' + i"
                                            [name]="'approvalReference' + i"
                                            [(ngModel)]="variationApproval.approvalReference"
                                            [required]="!isApprovalReferenceDisabled(variationApproval)"
                                            [disabled]="isApprovalReferenceDisabled(variationApproval)"
                                            #approvalReference="ngModel" />
                                    </div>
                                </td>
                                <td
                                    nowrap
                                    class="vertical-middle actions">
                                    <div class="actions">
                                        <div class="button-group">
                                            @if (last) {
                                                <button
                                                    class="nlr-btn-bg-transparent"
                                                    type="button"
                                                    tabindex="0"
                                                    title="Click to add variation approval"
                                                    [disabled]="isAddVariationApprovalDisabled()"
                                                    (click)="addVariationApproval()">
                                                    <i class="nlrp-icon nlrp-icon-add-circle"></i>
                                                </button>
                                            }
                                            <button
                                                class="nlr-btn-bg-transparent"
                                                type="button"
                                                tabindex="0"
                                                title="Click to remove variation approval"
                                                [disabled]="isRemoveVariationApprovalDisabled()"
                                                (click)="removeVariationApproval(i)">
                                                <i class="nlrp-icon nlrp-icon-remove-circle"></i>
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
}
